import React, {useEffect, useState} from 'react';
import 'antd/dist/antd.min.css';
import {Button, Modal} from "antd";
import './style.scss'

const saleImg = 'https://d1mluz1pfkw29o.cloudfront.net/img/background.png';

const SaleModal = (props) => {
    const [isOpen, setIsOpen] = useState(props.isOpen)
    return (
        <Modal className={'sales-modal'}
               visible={isOpen}
               footer={null}
               title={null}
               onCancel={() => setIsOpen(false)}>
            <img
                src={saleImg}
                alt={'sale-img'}
                className={'sales-img'}
            />
            <Button className={'sales-order-btn'}
                    onClick={() => window.location.href = 'https://vieunite.com/digital-canvas/'}>
                ORDER NOW
            </Button>
        </Modal>
    )
}
export default SaleModal;
